module.exports = __webpack_public_path__ + "media/icons/documents72-44262d83.png";